import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["bulkField", "overwrite", "rows", "template"];
  static values = { index: Number };

  add(event) {
    event.preventDefault();

    const count = Number.parseInt(event.currentTarget.dataset.count || "1", 10);
    for (let i = 0; i < count; i += 1) {
      this.appendRow();
    }
  }

  remove(event) {
    event.preventDefault();
    event.currentTarget.closest("tr")?.remove();
  }

  applyBulk(event) {
    event.preventDefault();

    const overwrite = this.hasOverwriteTarget && this.overwriteTarget.checked;
    this.bulkFieldTargets.forEach((bulkField) => {
      if (bulkField.value === "") return;

      this.rowsTarget.querySelectorAll(`[data-field="${bulkField.dataset.field}"]`).forEach((rowField) => {
        if (overwrite || rowField.value === "") {
          rowField.value = bulkField.value;
          rowField.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    });
  }

  appendRow() {
    const html = this.templateTarget.innerHTML.replaceAll("__INDEX__", this.indexValue);
    this.rowsTarget.insertAdjacentHTML("beforeend", html);
    this.indexValue += 1;
  }
}
